import React from 'react';
// import { MessageSquare } from 'lucide-react';
import yinhao from '@/imgs/CustomerNeedsRecognition/yinhao.png';
interface CustomerNeedsRecognitionProps {
  userQuestion?: string;
  extractedNeeds?: string;
}

const CustomerNeedsRecognition: React.FC<CustomerNeedsRecognitionProps> = ({
  userQuestion = '我最近想布局消费板块，有哪些表现好的基金、ETF 可以推荐？新能源主题的产品也想看看，最好是适合中长期持有的。',
  extractedNeeds = '消费板块、新能源板块基金/ETF推荐'
}) => {
  return (
    <div
      className="my-3 space-y-3 rounded-lg p-3"
      style={{
        background: 'linear-gradient(265deg, #F7FAFF 12.58%, #FFFCFC 87.65%)',
        boxShadow: 'inset 0 4px 4px 0 rgba(255, 255, 255, 0.67)'
      }}
    >
      {/* 用户问题卡片 */}
      <div
        className="rounded-lg border p-3"
        style={{
          background: 'linear-gradient(267deg, #EEEDFF 4.19%, #F6F7FF 86.14%)'
        }}
      >
        <div className="flex gap-2.5">
          {/* 引号图标 */}
          <div className="h-6 w-6 overflow-hidden">
            <img src={yinhao} alt="引号" className="h-full w-full object-cover" />
          </div>
          {/* 用户问题文本 */}
          <div className="flex-1">
            <p className="text-left text-xs leading-relaxed text-[#1F1F1F]">{userQuestion}</p>
          </div>
        </div>
      </div>

      {/* 需求提取区域 */}
      <div className="space-y-1">
        <h3 className="text-left text-sm font-semibold text-[#1F1F1F]">需求提取</h3>

        {/* 提取结果卡片 */}
        <div
          className="rounded-lg p-3"
          style={{
            border: '1px solid #3215F3',
            background: 'linear-gradient(267deg, #EEEDFF 4.19%, #F6F7FF 86.14%)',
            boxShadow: '0 4px 4px 0 rgba(255, 255, 255, 0.67) inset'
          }}
        >
          <p className="text-left text-xs leading-relaxed text-[#1F1F1F]">
            产品推荐：<span className="font-semibold text-[#5959EB]">{extractedNeeds}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerNeedsRecognition;
